import { Flex, Link, Text } from "@hopper-ui/components";
import { WarningIcon } from "@hopper-ui/icons";
import { useShellTranslation } from "../../../i18n/i18next.ts";
import { useTrackButtonClicked } from "../../../tracking/useTrackEvent.ts";
import { upsellAction } from "../../../upsellAction.ts";
import { useSubscriptionBanners } from "../../../useSubscriptionBanners.ts";

const CONTACT_TRIGGER = "Contact us";

export function BlockedSubscriptionBanner() {
    const { t } = useShellTranslation();
    const trackButtonClicked = useTrackButtonClicked();
    const { isBlockedBannerVisible, channel } = useSubscriptionBanners();

    if (!isBlockedBannerVisible) {
        return null;
    }

    const handleContactClick = () => {
        trackButtonClicked(CONTACT_TRIGGER, "BlockedSubscriptionBanner");
        upsellAction();
    };

    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="inline-sm"
            backgroundColor="danger-weak"
            color="danger-weak"
            padding="inset-squish-md"
            data-public
        >
            <Flex alignItems="center" gap="inline-sm">
                <WarningIcon size="sm" flexShrink={0} />
                <Text size="sm">{t("BlockedSubscriptionBanner.message")}</Text>
                {channel === "reseller" && <Text size="sm">{t("BlockedSubscriptionBanner.contactReseller")}</Text>}
            </Flex>
            {channel === "direct" && (
                <Link size="sm" color="inherit" onPress={handleContactClick}>
                    {t("BlockedSubscriptionBanner.contact")}
                </Link>
            )}
        </Flex>
    );
}
